import { Avatar, Skeleton, Steps, Tooltip } from "antd";
import ResizeObserver from "resize-observer-polyfill";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { MdEmail } from "react-icons/md";
import "./index.less";
import { DsersTrackingCoreV1GetTrackingPageInlineReply } from "./interface";
import {
  code_data,
  custom_data,
  dieInfo,
  getTrackingInfoErr,
  getTrackingInfoErr2,
  shippingInfoText,
} from "./mappingCodeInfo";

interface ITrackingTempleteProps {
  from: "dsers" | "tracking";
  renderData?: DsersTrackingCoreV1GetTrackingPageInlineReply;
  loading?: boolean;
  shipLoading?: boolean;
  productLoading?: boolean;
  changeBackgroundColor?: boolean;
}

const currenctColor: Record<string, string> = {
  ColorSet_Black: "#25282C",
  ColorSet_Blue: "#3D5AFE",
  ColorSet_Green: "#495242",
  ColorSet_Nil: "#25282C",
};

const statusMap = ["pend", "await", "pick", "ship", "deliver"];

const statusMapEN = ["Pending", "ToPickuped", "Pickuped", "Sented", "Finished"];

const renderGreenTopStep = [
  {
    key: 0,
    img: "https://img.dsers.com/dsers-business-image/pending_green.png",
  },
  { key: 1, img: "https://img.dsers.com/dsers-business-image/await_green.png" },
  {
    key: 2,
    img: "https://img.dsers.com/dsers-business-image/pickUP_green.png",
  },
  {
    key: 3,
    img: "https://img.dsers.com/dsers-business-image/shipped_green.png",
  },
  {
    key: 4,
    img: "https://img.dsers.com/dsers-business-image/delive_green.png",
  },
];

const renderBlueTopStep = [
  {
    key: 0,
    img: "https://img.dsers.com/dsers-business-image/pending_blue.png",
  },
  { key: 1, img: "https://img.dsers.com/dsers-business-image/await_blue.png" },
  {
    key: 2,
    img: "https://img.dsers.com/dsers-business-image/pickUp_blue.png",
  },
  {
    key: 3,
    img: "https://img.dsers.com/dsers-business-image/shiped_blue.png",
  },
  {
    key: 4,
    img: "https://img.dsers.com/dsers-business-image/delive_blue.png",
  },
];

const renderBlackTopStep = [
  {
    key: 0,
    img: "https://img.dsers.com/dsers-business-image/pending_black.png",
  },
  { key: 1, img: "https://img.dsers.com/dsers-business-image/await_black.png" },
  {
    key: 2,
    img: "https://img.dsers.com/dsers-business-image/pickUp_black.png",
  },
  {
    key: 3,
    img: "https://img.dsers.com/dsers-business-image/shipped_black.png",
  },
  {
    key: 4,
    img: "https://img.dsers.com/dsers-business-image/delive_black.png",
  },
];

const blackTopImg = [
  "https://img.dsers.com/dsers-business-image/black_top1.png",
  "https://img.dsers.com/dsers-business-image/black_top2.png",
  "https://img.dsers.com/dsers-business-image/black_top3.png",
  "https://img.dsers.com/dsers-business-image/black_top4.png",
];

const greenTopImg = [
  "https://img.dsers.com/dsers-business-image/green_top1.png",
  "https://img.dsers.com/dsers-business-image/green_top2.png",
  "https://img.dsers.com/dsers-business-image/green_top3.png",
  "https://img.dsers.com/dsers-business-image/green_top4.png",
];

const blueTopImg = [
  "https://img.dsers.com/dsers-business-image/blue_top1.png",
  "https://img.dsers.com/dsers-business-image/blue_top2.png",
  "https://img.dsers.com/dsers-business-image/blue_top3.png",
  "https://img.dsers.com/dsers-business-image/blue_top4.png",
];

function debounce(fn: Function, delay: number) {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export default function TrackingTemplete(props: ITrackingTempleteProps) {
  const {
    from,
    renderData,
    loading,
    shipLoading,
    productLoading,
    changeBackgroundColor,
  } = props;

  console.log(99999, from, loading, renderData);
  const containerRef = useRef<HTMLDivElement>(null);
  const trackingRef = useRef<HTMLDivElement>(null);
  const [tempWidth, setTempWidth] = useState(window.innerWidth);
  const [TackingWidth, setTackingWidth] = useState(1000);
  const statusTopStep = useMemo(() => {
    return statusMap.map((it, ind) => {
      return {
        title:
          custom_data?.[it as keyof typeof custom_data]?.[
            renderData?.languageSet || "EN"
          ],
        description:
          renderData?.tracking?.trackingStatus?.find(
            (i) => i?.trackType === statusMapEN?.[ind],
          )?.accessTime || "--",
      };
    });
  }, [renderData?.tracking?.trackingStatus, renderData?.languageSet]);

  useEffect(() => {
    const element = trackingRef.current;
    if (!element) return;

    const handleResize = debounce((entries: ResizeObserverEntry[]) => {
      for (let entry of entries) {
        const newWidth = entry.contentRect.width;
        setTackingWidth(newWidth);
      }
    }, 200);

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(element);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const currenctIsErrorEmail = useMemo(() => {
    const isError = renderData?.customerSupportEmail === "" ? true : false;
    const isErrorEmail = Object.prototype.hasOwnProperty.call(
      renderData || {},
      "isErrorEmail",
    )
      ? renderData?.isErrorEmail === undefined
        ? isError
        : renderData?.isErrorEmail
      : isError;

    return isErrorEmail;
  }, [renderData]);

  const statusBottomStep = useMemo(() => {
    return renderData?.tracking?.trackingData?.detail?.map((it) => {
      return {
        title:
          code_data?.[it.operateNode as keyof typeof code_data]?.[
            renderData.languageSet || "EN"
          ],
        description: it.operateTime,
      };
    });
  }, [renderData?.tracking?.trackingData, renderData?.languageSet]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleResize = debounce((entries: ResizeObserverEntry[]) => {
      for (let entry of entries) {
        const newWidth = entry.contentRect.width;
        if (Math.abs(tempWidth - newWidth) > 10) {
          setTempWidth(newWidth);
        }
      }
    }, 200);

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [tempWidth]);

  const getErrorTip = () => {
    if (shipLoading) {
      return (
        <>
          <Skeleton active />
          <Skeleton active />
        </>
      );
    }
    if (
      renderData?.status === "Draft" &&
      renderData.storeId == "0" &&
      !shipLoading &&
      from === "tracking"
    ) {
      return (
        <div
          className="noData"
          style={{
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: 400,
            color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
          }}
        >
          {getTrackingInfoErr[renderData?.languageSet || "EN"]}
        </div>
      );
    }
    if (
      (!renderData?.tracking?.trackingStatus?.length &&
        !shipLoading &&
        from === "tracking") ||
      (!renderData?.tracking && !shipLoading && from === "tracking")
    ) {
      return (
        <div
          className="noData"
          style={{
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "14px",
            fontWeight: 400,
            color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
          }}
        >
          {getTrackingInfoErr2[renderData?.languageSet || "EN"]}
        </div>
      );
    }
    return null;
  };

  console.log("resColor", renderData);
  const currenctBac = useMemo(() => {
    if (renderData?.color === "ColorSet_Green") {
      return renderGreenTopStep;
    } else if (renderData?.color === "ColorSet_Blue") {
      return renderBlueTopStep;
    } else {
      return renderBlackTopStep;
    }
  }, [renderData?.color]);

  const currenctTopImg = useMemo(() => {
    if (renderData?.color === "ColorSet_Blue") {
      return blueTopImg;
    } else if (renderData?.color === "ColorSet_Green") {
      return greenTopImg;
    } else {
      return blackTopImg;
    }
  }, [renderData?.color]);

  const currenctClassName = useMemo(() => {
    if (renderData?.color === "ColorSet_Blue") {
      return "detailStepBoxBlue";
    } else if (renderData?.color === "ColorSet_Green") {
      return "detailStepBoxGreen";
    } else {
      return "detailStepBoxBlack";
    }
  }, [renderData?.color]);

  const currenctAllImg = useMemo(() => {
    let img = {
      car: "https://img.dsers.com/dsers-business-image/black_transit.png",
      trackNumber:
        "https://img.dsers.com/dsers-business-image/black_track_number.png",
      stepIcon: "",
      timeIcon: "https://img.dsers.com/dsers-business-image/black_time.png",
      hot: "https://img.dsers.com/dsers-business-image/black_hot.png",
      flayPc: "https://img.dsers.com/dsers-business-image/black_flay_pc.png",
      flayM: "https://img.dsers.com/dsers-business-image/black_flay_mobel.png",
    };
    if (renderData?.color === "ColorSet_Blue") {
      img = {
        car: "https://img.dsers.com/dsers-business-image/blue_transit.png",
        trackNumber:
          "https://img.dsers.com/dsers-business-image/blue_track_number.png",
        stepIcon: "",
        timeIcon: "https://img.dsers.com/dsers-business-image/blue_time.png",
        hot: "https://img.dsers.com/dsers-business-image/blue_hot.png",
        flayPc: "https://img.dsers.com/dsers-business-image/blue_flay_pc.png",
        flayM: "https://img.dsers.com/dsers-business-image/blue_flay_mobel.png",
      };

      return img;
    } else if (renderData?.color === "ColorSet_Green") {
      img = {
        car: "https://img.dsers.com/dsers-business-image/green_transit.png",
        trackNumber:
          "https://img.dsers.com/dsers-business-image/green_track_number.png",
        stepIcon: "",
        timeIcon: "https://img.dsers.com/dsers-business-image/green_time.png",
        hot: "https://img.dsers.com/dsers-business-image/green_hot.png",
        flayPc: "https://img.dsers.com/dsers-business-image/green_flay_pc.png",
        flayM:
          "https://img.dsers.com/dsers-business-image/green_flay_nobel.png",
      };
      return img;
    } else {
      img = {
        car: "https://img.dsers.com/dsers-business-image/black_transit.png",
        trackNumber:
          "https://img.dsers.com/dsers-business-image/black_track_number.png",
        stepIcon: "",
        timeIcon: "https://img.dsers.com/dsers-business-image/black_time.png",
        hot: "https://img.dsers.com/dsers-business-image/black_hot.png",
        flayPc: "https://img.dsers.com/dsers-business-image/black_flay_pc.png",
        flayM:
          "https://img.dsers.com/dsers-business-image/black_flay_mobel.png",
      };
      return img;
    }
  }, [renderData?.color]);

  const activeStatusInfo = useMemo(() => {
    const lang = renderData?.languageSet || "EN";
    const statusList = renderData?.tracking?.trackingStatus || [];
    const currenctData = from === "tracking" ? statusBottomStep : dieInfo[lang];
    const activeIndex = statusList.reduce((prev, current) => {
      const index = statusMapEN.indexOf(current.trackType || "");
      return index > prev ? index : prev;
    }, -1);
    const badgeLabel =
      activeIndex >= 0
        ? custom_data?.[statusMap[activeIndex] as keyof typeof custom_data]?.[
            lang
          ]
        : "--";
    const badgeTime =
      activeIndex >= 0
        ? statusList.find((item) => item.trackType === statusMapEN[activeIndex])
            ?.accessTime || ""
        : "";
    const statusTitle = currenctData?.[0]?.title || "";
    const statusSub = currenctData?.[0]?.description || "";
    return {
      badgeLabel,
      badgeTime,
      statusTitle,
      statusSub,
    };
  }, [renderData?.tracking?.trackingStatus, renderData?.languageSet]);
  const TitleW = "Track Your Order, View the latest shipping updates below.";

  console.log(3333, TackingWidth);
  return (
    <div
      className={`TrackingTempleteContainer ${tempWidth < 700 ? "mobile" : ""}`}
      ref={containerRef}
    >
      <div
        id="TrackingTemplete"
        className="TrackingTemplete"
        ref={trackingRef}
        style={{
          backgroundColor: changeBackgroundColor ? "#fff" : undefined,
        }}
      >
        <div className="headerInfo">
          <div className="headerLeft">
            <div className="icon">
              {renderData?.logo ? (
                <img src={renderData?.logo} alt="" />
              ) : (
                <span>LOGO</span>
              )}
            </div>
            <div className="nameSpace">
              <span className="name">{renderData?.storeName}</span>
              <span className="desc">{renderData?.pageInfo}</span>
            </div>
          </div>
          {currenctIsErrorEmail ? null : (
            <div className="emailIcon">
              {" "}
              <Tooltip title={renderData?.customerSupportEmail}>
                <a href={`mailto:${renderData?.customerSupportEmail}`}>
                  <MdEmail
                    style={{
                      fontSize: "16px",
                      color:
                        currenctColor?.[
                          renderData?.color ?? "ColorSet_Black"
                        ] || "#25282C",
                    }}
                  />
                </a>
              </Tooltip>
            </div>
          )}
        </div>
        <div
          className="statusSummary"
          style={{
            backgroundImage:
              tempWidth < 780
                ? `url(${currenctAllImg.flayM})`
                : `url(${currenctAllImg.flayPc})`,
            backgroundSize: "100% 100%",
          }}
        >
          <div className="statusSummaryLeft">
            <div className="statusSummaryTitle">
              <div>
                <img src={currenctAllImg.car} alt="" />
              </div>
              <div>
                {/* activeStatusInfo.statusTitle */}
                {TitleW.split(/\s*,\s*/).map((item, index) => (
                  <div key={index} className="statusSummaryTitleLine">
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* <div className="statusSummaryDesc">
              {activeStatusInfo.statusSub}
            </div> */}
            <div className="statusSummaryBadge">
              <img src={currenctBac[currenctBac.length - 1].img} alt="" />
              <span className="badgeText">{activeStatusInfo.badgeLabel}</span>
              {activeStatusInfo.badgeTime ? (
                <span className="badgeDate">{activeStatusInfo.badgeTime}</span>
              ) : null}
            </div>
          </div>
        </div>

        <MobelSteps
          renderData={renderData}
          statusTopStep={statusTopStep}
          tempWidth={tempWidth}
          currenctBac={currenctBac}
        />
        <div
          className="tracking"
          style={{
            color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
          }}
        >
          <img src={currenctAllImg.trackNumber} alt="" />
          {shippingInfoText[renderData?.languageSet || "EN"]}
          <span>{renderData?.tracking?.trackingNumber}</span>
        </div>
        {getErrorTip() ? (
          getErrorTip()
        ) : (
          <div className={currenctClassName}>
            {TackingWidth > 400 ? (
              <div className="stepsContainer">
                <Steps
                  progressDot
                  current={0}
                  direction="vertical"
                  style={{
                    color:
                      currenctColor?.[renderData?.color ?? "ColorSet_Black"],
                  }}
                  items={
                    from === "tracking"
                      ? statusBottomStep?.slice(0, 5)
                      : dieInfo[renderData?.languageSet || "EN"]?.slice(0, 5)
                  }
                />
                {dieInfo[renderData?.languageSet || "EN"]?.length > 5 && (
                  <Steps
                    progressDot
                    current={-1}
                    style={{
                      color:
                        currenctColor?.[renderData?.color ?? "ColorSet_Black"],
                    }}
                    direction="vertical"
                    items={
                      from === "tracking"
                        ? statusBottomStep?.slice(5)
                        : dieInfo[renderData?.languageSet || "EN"]?.slice(5)
                    }
                  />
                )}
              </div>
            ) : (
              <div className="stepsContainer">
                <Steps
                  progressDot
                  current={0}
                  direction="vertical"
                  style={{
                    color:
                      currenctColor?.[renderData?.color ?? "ColorSet_Black"],
                  }}
                  items={
                    from === "tracking"
                      ? statusBottomStep
                      : dieInfo[renderData?.languageSet || "EN"]
                  }
                />
              </div>
            )}
          </div>
        )}
        {renderData?.bestSellerSet === "open" && (
          <div
            className="mobileHotItemsBox"
            style={{
              backgroundColor: changeBackgroundColor ? "#fff" : undefined,
            }}
          >
            <div
              className="header"
              style={{
                color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
              }}
            >
              {" "}
              <img src={currenctAllImg.hot} alt="" /> Hot Items
            </div>
            {productLoading ? (
              <></>
            ) : (
              <div className="list">
                {renderData?.productDetails?.map((item, index) => (
                  <div
                    className="item"
                    key={item.productId}
                    style={{
                      border: `1px solid ${currenctColor?.[renderData?.color ?? "ColorSet_Black"]}`,
                    }}
                  >
                    <img src={item.productImage} alt="" />
                    <div
                      className="titleBox"
                      style={{ marginTop: index === 3 ? 4 : 0 }}
                    >
                      <span className="title">
                        <a
                          href={item.productLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={currenctTopImg[index]}
                            alt=""
                            style={{
                              width: index === 3 ? "32px" : "57px",
                              height: "100%",
                            }}
                          />
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {renderData?.bestSellerSet === "open" && (
          <div
            className="hotItemsBox"
            style={{
              backgroundColor: changeBackgroundColor ? "#fff" : undefined,
            }}
          >
            <div
              className="header"
              style={{
                color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
              }}
            >
              {" "}
              <img src={currenctAllImg.hot} alt="" /> Hot Items
            </div>
            {productLoading ? (
              <>
                <Skeleton.Image
                  active
                  style={{ width: "100%", height: "100%" }}
                />
                <Skeleton.Image
                  active
                  style={{ width: "100%", height: "100%" }}
                />
                <Skeleton.Image
                  active
                  style={{ width: "100%", height: "100%" }}
                />
                <Skeleton.Image
                  active
                  style={{ width: "100%", height: "100%" }}
                />
              </>
            ) : (
              <div className="list">
                {renderData?.productDetails?.map((item: any, index) => (
                  <div
                    className="item"
                    key={item.productId}
                    style={{
                      border: `1px solid ${currenctColor?.[renderData?.color ?? "ColorSet_Black"]}`,
                    }}
                  >
                    <img src={item.productImage} alt="" />
                    <div
                      className="titleBox"
                      style={{ marginTop: index === 3 ? 4 : 0 }}
                    >
                      <span className="title">
                        <a
                          href={item.productLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={currenctTopImg[index]}
                            alt=""
                            style={{
                              width: index === 3 ? "32px" : "57px",
                              height: "100%",
                            }}
                          />
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

const MobelSteps = React.memo(
  ({
    renderData,
    statusTopStep,
    tempWidth,
    currenctBac,
  }: {
    renderData?: any;
    statusTopStep?: any[];
    tempWidth?: any;
    currenctBac?: any;
  }) => {
    return (
      <div
        className="StepsIconBox"
        style={{
          padding: tempWidth < 780 ? "0" : "0",
          marginBottom: tempWidth < 780 ? "100px" : "70px",
        }}
      >
        <div className="stepImg">
          <div
            className="imageCon"
            style={{
              color: currenctColor?.[renderData?.color ?? "ColorSet_Black"],
            }}
          >
            <img
              src={currenctBac[0]?.img || statusTopStep?.[0]?.img || []}
              alt=""
            />
            <div
              className="oneOfdesc"
              style={{
                width: tempWidth < 780 ? "76px" : "200px",
              }}
            >
              <span className="title">{statusTopStep?.[0].title}</span>
              <span className="time">
                {statusTopStep?.[0]?.description || "--"}
              </span>
            </div>
          </div>
          <div className="imageBox">
            {currenctBac
              .filter((i: any) => i.key !== 0)
              .map((item: any, index: number) => {
                return (
                  <div className="oneOfimg" key={item.key}>
                    <div
                      className="line"
                      style={{
                        backgroundColor:
                          currenctColor?.[
                            renderData?.color ?? "ColorSet_Black"
                          ],
                      }}
                    ></div>
                    <div
                      className="imageCon"
                      style={{
                        color:
                          currenctColor?.[
                            renderData?.color ?? "ColorSet_Black"
                          ],
                      }}
                    >
                      <img src={item.img} alt="" />
                      <div
                        className="oneOfdesc"
                        style={{
                          width: tempWidth < 780 ? "76px" : "200px",
                        }}
                      >
                        <span className="title">
                          {statusTopStep?.[index + 1]?.title}
                        </span>
                        <span className="time">
                          {statusTopStep?.[index + 1]?.description}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  },
);
